export default __webpack_public_path__ + "static/media/two-women-shopping-cart.49c341b7.jpg";